import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';

const AdmissionBannerWithForm = () => {
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_tk5zqjo',       // ✅ Your actual service ID
      'template_r81rr53',      // ✅ Your actual template ID
      formRef.current,
      'bP79j8Y-gS9V79CJ0'      // ✅ Your actual public key
    ).then(() => {
      alert("✅ Application submitted successfully!");
      formRef.current.reset();
      setShowForm(false);
    }).catch((error) => {
      console.error(error);
      alert("❌ Failed to submit form.");
    });
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '15px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  };

  const submitStyle = {
    backgroundColor: '#125303',
    color: '#fff',
    padding: '12px 25px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  return (
    <>
      <section
        className="admission-banner"
        style={{
          overflow: 'hidden',
          width: '100%',
          backgroundImage: 'url("/banner/admission-banner.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          padding: '80px 20px',
          textAlign: 'center',
          color: '#fff',
          position: 'relative',
        }}
      >
        <div className="container" style={{ maxWidth: '1140px', margin: '0 auto' }}>
          <div
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              padding: '50px 30px',
              borderRadius: '12px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
            }}
          >
            <h2 style={{ fontSize: '2.8rem', marginBottom: '20px', fontWeight: 'bold' }}>
              Admissions Open for 2025–26 🎓
            </h2>
            <p style={{ fontSize: '1.2rem', marginBottom: '30px' }}>
              Enroll your child at Universal Academy and give them the future they deserve.
            </p>
            <button
              onClick={() => setShowForm(true)}
              style={{
                padding: '14px 28px',
                backgroundColor: '#fcd34d',
                color: '#000',
                fontWeight: 'bold',
                borderRadius: '8px',
                boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                cursor: 'pointer',
              }}
            >
              Apply Now
            </button>
          </div>
        </div>
      </section>

      {showForm && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '30px',
            borderRadius: '10px',
            maxWidth: '500px',
            width: '100%',
            position: 'relative',
          }}>
            <h2 style={{ marginBottom: '20px', color: '#125303' }}>Admission Application Form</h2>
            <form ref={formRef} onSubmit={sendEmail}>
              <input type="text" name="from_name" placeholder="Full Name" required style={inputStyle} />
              <input type="email" name="email" placeholder="Email Address" required style={inputStyle} />
              <input type="tel" name="phone" placeholder="Phone Number" required style={inputStyle} />
              <input type="text" name="class" placeholder="Class Applying For" required style={inputStyle} />
              <textarea name="message" placeholder="Message (optional)" rows="3" style={inputStyle} />
              <button type="submit" style={submitStyle}>Submit</button>
            </form>
            <button onClick={() => setShowForm(false)} style={{
              position: 'absolute', top: '10px', right: '15px', fontSize: '18px', background: 'none',
              border: 'none', cursor: 'pointer'
            }}>✕</button>
          </div>
        </div>
      )}
    </>
  );
};

export default AdmissionBannerWithForm;
